export function formatDisplayCredits(value: number): string {
  return String(Math.round(value));
}

export function formatCreditPeriodRemaining(
  periodEnd: string | null | undefined,
  now = new Date(),
): string | null {
  const endDate = parseDateOnly(periodEnd);
  if (!endDate) return null;

  const todayUtc = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
  );
  const endUtc = Date.UTC(endDate.year, endDate.month - 1, endDate.day);
  const daysLeft = Math.ceil((endUtc - todayUtc) / 86_400_000);

  if (daysLeft < 0) return "Credit period ended";
  if (daysLeft === 0) return "Last day of credit period";
  if (daysLeft === 1) return "1 day left";

  return `${daysLeft} days left`;
}

function parseDateOnly(value: string | null | undefined): {
  year: number;
  month: number;
  day: number;
} | null {
  if (!value) return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return null;
  const [, year, month, day] = match;
  if (!year || !month || !day) return null;

  return {
    year: Number(year),
    month: Number(month),
    day: Number(day),
  };
}
